import React, {useEffect, useState} from 'react';
import {Bar} from 'react-chartjs-2';
import {Chart, ChartData, TooltipItem, CategoryScale, LinearScale, BarElement } from 'chart.js';
import {formatDateShort, getHibuTextLightColor, getHibuThemeColor} from '../utils/utils';
import moment from 'moment';
import {HistogramSnapPoint} from './histogram';
import {useLocalizationUtil} from '../localizationUtil';

type BarChartProps = {
    data: HistogramSnapPoint[];
    highlight: number[];
    domain: number[];
};

interface BarDataValue {
    x: number;
    y: number;
    formatedValue: string;
    color: string;
    label: string;
}

export const BarChart = React.memo(({data, highlight, domain: [from, to]}: BarChartProps) => {
    const [barData, setBarData] = useState<ChartData<'bar'>>();
    const hibuThemeColor = getHibuThemeColor();
    const hibuTextLightColor = getHibuTextLightColor();
    const {formatNumber} = useLocalizationUtil();
    Chart.register(CategoryScale, LinearScale, BarElement);

    useEffect(() => {
        // calculate frequency of data
        const counts = {};
        data.forEach(({value, count}) => {
            const date = new Date(value).valueOf();
            counts[date] = count + (counts[date] || 0);
        });

        // generate data
        const values: BarDataValue[] = [];
        for (let x = from; x <= to; x = moment.utc(x).add(1, 'months').toDate().valueOf()) {
            values.push({
                x: x,
                y: counts[x] || 0,
                formatedValue: formatNumber(counts[x] || 0),
                color: x >= highlight[0] && x <= highlight[1] ? hibuThemeColor : hibuTextLightColor,
                label: formatDateShort(x),
            });
        }

        setBarData({
            labels: values.map(({label}) => label),
            datasets: [
                {
                    backgroundColor: values.map(({color}) => color),
                    data: values.map(({y}) => y),
                },
            ],
        });
    }, [data, from, to, hibuThemeColor, hibuTextLightColor, highlight, formatNumber]);

    if (!barData) {
        return <></>;
    }

    return (
        <Bar
            data={barData}
            options={{
                responsive: true,
                plugins: {
                    legend: {
                        display: false,
                    },
                    tooltip: {
                        callbacks: {
                            label: function (tooltipItem: TooltipItem<any>) {
                                return tooltipItem.formattedValue;
                            },

                        },
                    }
                },
                scales: {
                    x: {
                        display: false,
                    },
                    y: {
                        display: false,
                    },
                },
            }}
        />
    );
});
